import React, { useState } from "react";
import axios from "axios";
import { FiArrowRight } from "react-icons/fi";
import Loader from "./Loader";
import PageHead from "./PageHead";
import { GEMINI_URL } from "../constants";

const SUGGESTIONS = ["REST APIs", "Database indexing", "Microservices", "Kafka"];

const Fact = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState([]);
  const [error, setError] = useState("");

  const generateAnswer = async (topic = question) => {
    if (!topic.trim()) return;
    setIsLoading(true);
    setError("");
    try {
      const prompt =
        "Give me as many questions and answers as you can on this topic: " +
        topic +
        '. Ensure the response is a valid JSON array that I can parse directly using JSON.parse(). Do not include any extra text, explanations, or formatting. Just return a JSON array like this: [{"q": "What is AI?", "ans": "AI is artificial intelligence."}, {"q": "What is ML?", "ans": "Machine learning is a subset of AI."}].';
      const response = await axios.post(GEMINI_URL, { contents: [{ parts: [{ text: prompt }] }] });
      const match = response.data.candidates[0].content.parts[0].text.match(/\[.*\]/s);
      setAnswer(JSON.parse(match[0]));
    } catch {
      setAnswer([]);
      setError("Couldn't build a drill for that topic. Try rephrasing it.");
    }
    setIsLoading(false);
  };

  return (
    <div className="container tool-page">
      <PageHead
        num="02"
        label="QuickLearn"
        line1="Drill a concept"
        line2="in five minutes."
        lead="Enter a technical topic and get interview-style questions. Try answering before you open each one."
      />

      <div className="card tool-input reveal">
        <textarea
          className="textarea"
          style={{ minHeight: 64 }}
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              generateAnswer();
            }
          }}
          placeholder="e.g. REST APIs, Database Indexing, Microservices Architecture"
        />
        <div className="tool-input__bar">
          <span className="eyebrow">Enter to generate</span>
          <button className="btn btn--accent" onClick={() => generateAnswer()} disabled={isLoading || !question.trim()}>
            Build drill <FiArrowRight />
          </button>
        </div>
      </div>

      <div className="chips suggestions">
        {SUGGESTIONS.map((s) => (
          <button
            key={s}
            className="chip chip--filter"
            onClick={() => {
              setQuestion(s);
              generateAnswer(s);
            }}
          >
            {s}
          </button>
        ))}
      </div>

      {(isLoading || answer.length > 0 || error) && (
        <section className="card output reveal">
          <div className="output__head">
            <h2 className="eyebrow">Questions</h2>
            {answer.length > 0 && !isLoading && <span className="eyebrow num">{answer.length} cards</span>}
          </div>
          {isLoading ? (
            <div className="output__body">
              <Loader inline label="Building your drill…" />
            </div>
          ) : error ? (
            <div className="output__body">
              <p className="alert">{error}</p>
            </div>
          ) : (
            <div className="qa-list">
              {answer.map((a, i) => (
                <details className="qa" key={i}>
                  <summary>
                    <span className="qa__num num">{String(i + 1).padStart(2, "0")}</span>
                    {a.q}
                  </summary>
                  <p>{a.ans}</p>
                </details>
              ))}
            </div>
          )}
        </section>
      )}
    </div>
  );
};

export default Fact;
